import { useApi } from "@/composition/useApi.js";
function createTableBody(state) {
  const arr = [];
  state.points.forEach(point => {
    const obj = {};
    state.columnOrder.forEach(key => {
      obj[key] = point[key];
    });
    arr.push(obj);
  });
  state.tableData.body = arr;
}
export default {
  state: () => ({
    sensors: [], // массив всех доступных сенсоров
    namedSensors: [], // массив именованных сенсоров из беки
    terminals: null, // массив всех терминалов для Select Options
    points: null, // массив всех сырых данных
    isSpinerMainList: false,
    isLoading: false, // глобальная загрузка
    tableData: {
      headers: {}, // headers таблицы
      body: [], // тело таблицы
    },

    columnOrder: [], // порядок колонок
    errorMessage: "", // сообщение об ошибке
  }),
  mutations: {
    setRDPoints(state, payload) {
      if (!payload || payload.length === 0) {
        state.points = [];
        state.errorMessage = "Данные отсутствуют";
        return;
      }
      state.points = payload.map(itm => {
        const obj = Object.assign(itm, itm.sourceData, itm.data);
        delete obj.sourceData;
        delete obj.data;
        obj.time = new Date(obj.time).toLocaleString("ru-RU");
        obj.createdAt = new Date(obj.createdAt).toLocaleString("ru-RU");
        return obj;
      });
      const sensorsArr = [];
      Object.keys(state.points[0]).forEach(itm => {
        // убираем время
        if (itm !== "time") {
          sensorsArr.push({
            checked: false,
            name: state.namedSensors[itm] ? state.namedSensors[itm] : itm,
            type: itm,
          });
        }
      });
      state.sensors = sensorsArr;
      state.tableData.headers["time"] = state.namedSensors["time"]
        ? state.namedSensors["time"]
        : "Время";
      state.columnOrder = ["time"];
      state.errorMessage = "";
      createTableBody(state);
    },
    setRDTerminals(state, payload) {
      state.terminals = payload;
    },
    setRDSensors(state, payload) {
      const obj = {};
      if (payload.length)
        payload.forEach(itm => {
          obj[itm.id] = itm.name;
        });
      obj.createdAt = "Создано";
      obj.id = "ID";
      obj.terminalId = "ID терминала";

      state.namedSensors = obj;
    },
    setRDActiveCheckbox(state, type) {
      const selectedSensor = state.sensors.find(itm => itm.type === type);

      selectedSensor.checked = !selectedSensor.checked;

      if (selectedSensor.checked) {
        state.tableData.headers[selectedSensor.type] = state.namedSensors[
          selectedSensor.type
        ]
          ? state.namedSensors[selectedSensor.type]
          : selectedSensor.type;
        state.columnOrder.push(selectedSensor.type);
      } else {
        delete state.tableData.headers[selectedSensor.type];
        state.columnOrder = state.columnOrder.filter(
          column => column !== selectedSensor.type,
        );
      }
      createTableBody(state);
    },
    setSpinerMainList(state, bool) {
      state.isSpinerMainList = bool;
    },
    setLoading(state, status) {
      state.isLoading = status;
    },
    clearRDData(state) {
      state.tableData = {
        headers: {},
        body: [],
      };
      state.sensors = [];
      state.namedSensors = [];
      state.points = null;
      state.columnOrder = [];
      state.columnOrder = [];
      state.errorMessage = "";
    },
  },
  actions: {
    getRDSensorsById({ commit }, id) {
      // RD means - Raw Data
      const { api } = useApi();
      return api.get(`/terminals/sensors/brief?terminalId=${id}`).then(r => {
        if (r.status == 200) commit("setRDSensors", r.data);
        return r;
      });
    },
    getRDPointsById({ commit }, payload) {
      const { api } = useApi();
      commit("setSpinerMainList", true);
      return api
        .get(
          `/points?terminalId=${payload.id}&from=${payload.from}&to=${payload.to}`,
        )
        .then(r => {
          if (r.status == 200) commit("setRDPoints", r.data);
          commit("setSpinerMainList", false);
          return r;
        });
    },
    getRDTerminals({ commit }) {
      commit("setLoading", true);
      const { api } = useApi();
      return api
        .get(`/terminals`)
        .then(r => {
          if (r.status == 200) commit("setRDTerminals", r.data);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
  },
};
